import { Col, Divider, Row } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import {
  selectBusinessPartner,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import moment from 'moment';
import { Block, Title } from '../..';
import TooltipParagraph from 'app/pages/Catalog/tooltipParagraph';
import { downloadSignedFile } from 'utils/helper';

interface Props {
  transactionData: Record<string, any>;
}

const Contract: React.FC<Props> = ({ transactionData }) => {
  const translations = useSelector(selectTranslations);
  const { data: businessPartner } = useSelector(selectBusinessPartner);
  const renderContractInfo = useCallback(
    value => {
      if (value !== null && value !== undefined) return value;
      return translations?.['b2b.txt.updating'];
    },
    [translations],
  );
  const endContract = useMemo(
    () => businessPartner?.extraInfo?.endContract,
    [businessPartner?.extraInfo?.endContract],
  );

  const startContract = useMemo(
    () => businessPartner?.extraInfo?.startContract,
    [businessPartner?.extraInfo?.startContract],
  );
  const onClickPdf = async () => {
    if (!businessPartner?.contractFile || !businessPartner?.contractFileName)
      return;
    await downloadSignedFile(businessPartner?.contractFile);
  };
  return (
    <Block>
      <Title>{translations?.['b2b.txt.contractInfo']}</Title>
      <Divider dashed style={{ borderColor: '#EDEDED', margin: '16px 0' }} />
      <Row style={{ flexDirection: 'column' }} gutter={[24, 24]}>
        <Col>
          <ContractTitle>
            {translations?.['b2b.txt.contractStatus']}
          </ContractTitle>
          <ContractValue style={{ color: '#FAB317' }}>
            {renderContractInfo(businessPartner?.contractStatusName || 'N/A')}
          </ContractValue>
        </Col>
        <Divider
          dashed
          style={{ margin: '0px 12px', borderColor: '#EDEDED' }}
        />
        <Col>
          <ContractTitle>
            {translations?.['b2b.txt.agent-contract-id']}
          </ContractTitle>
          <ContractValue>
            {renderContractInfo(
              businessPartner?.extraInfo?.contractNumber || 'N/A',
            )}
          </ContractValue>
        </Col>
        <Col>
          <ContractTitle>
            {translations?.['b2b.txt.agent-contract-date']}
          </ContractTitle>
          <ContractValue>
            {renderContractInfo(
              startContract ? moment(startContract).format('DD/MM/YYYY') : '',
            )}
          </ContractValue>
        </Col>
        <Col>
          <ContractTitle>
            {translations?.['b2b.txt.contract-expiration-date']}
          </ContractTitle>
          <ContractValue>
            {renderContractInfo(
              endContract ? moment(endContract).format('DD/MM/YYYY') : '',
            )}
          </ContractValue>
        </Col>
        <Col>
          <ContractTitle>
            {translations?.['b2b.txt.contractFile']}
          </ContractTitle>
          <ContractValue isHover onClick={onClickPdf}>
            <StyleTooltipParagraph
              isHover={!!businessPartner?.contractFileName}
            >
              {renderContractInfo(businessPartner?.contractFileName || 'N/A')}
            </StyleTooltipParagraph>
          </ContractValue>
        </Col>
      </Row>
    </Block>
  );
};

export default Contract;

const ContractTitle = styled.p`
  font-size: 14px;
  margin: 0;
  color: #000000;
  font-weight: 400;
`;

const ContractValue = styled.p<{ isHover?: boolean }>`
  font-size: 20px;
  margin: 0;
  color: #000000;
  font-weight: 500;
  margin-top: 4px;
  cursor: ${props => (props.isHover ? 'pointer' : 'default')};
`;
const StyleTooltipParagraph = styled(TooltipParagraph)<{ isHover?: boolean }>`
  &:hover {
    color: ${props => (props.isHover ? '#FAB317' : '#000000')};
    cursor: ${props => (props.isHover ? 'pointer' : 'default')};
  }
`;
